import { render, staticRenderFns } from "./CheckoutMercadoPagoComplete.vue?vue&type=template&id=7036872a"
import script from "./CheckoutMercadoPagoComplete.vue?vue&type=script&lang=js"
export * from "./CheckoutMercadoPagoComplete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports